import React from "react";
import "./Mission.css";

const Mission = () => {
  return (
    <section className="mission-section">
      <div className="mission-container">
        <h2 className="mission-title">Our Mission</h2>

        <h3 className="mission-tagline">
          Accelerating Talent. Securing Enterprise Growth.
        </h3>

        <p className="mission-description">
          The global pharmaceutical industry is defined by constant transformation,
          regulatory pressure, and the demand for disruptive innovation. PHARMA EMPOWER
          is an integrated knowledge firm operating at the intersection of talent
          elevation and operational excellence.
        </p>

        <p className="mission-description">
          Our mission is to accelerate both the individual professional and the
          enterprise itself.
        </p>

        <p className="mission-description">
          We achieve this by using experienced industry experts, smart consulting
          strategies, and modern learning platforms to help organizations grow
          safely, follow global regulations, and succeed worldwide.
        </p>
      </div>
    </section>
  );
};

export default Mission;
